import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Dropdown from '../Dropdown/Dropdown'
import {
  HoverLine,
  StyledIcon,
  StyledLink,
  StyledLinkGroup,
  StyledNavItem,
} from './NavbarItem.styled'

const NavbarItem = ({
  ariaLabel,
  links,
  name,
  slug,
  icon,
  className,
  scroll,
  menuLayout,
  additionalReference
}) => {
  const [isSelected, setIsSelected] = useState(false)

  const firstCharacter = slug.charAt(0)
  const to = firstCharacter.includes('/') ? slug : `/${slug}`
  const isBrowser = typeof window !== 'undefined'

  useEffect(() => {
    if (isBrowser) {
      const currentLocation = window.location.pathname
      const parentLocation = currentLocation.split('/')[1]
      const parentSlug = slug.split('/')[0]

      if (parentLocation === `${parentSlug}` && currentLocation !== '/') {
        setIsSelected(true)
      }
      if (parentLocation === 'results' && slug === '/results') {
        setIsSelected(true)
      }
      if (parentSlug === 'our-products' && parentLocation === 'products') {
        setIsSelected(true)
      }
    }
  }, [])
  return (
    <StyledNavItem className={className}>
      {links ? (
        <Dropdown
          isSelected={isSelected}
          label={name}
          links={links}
          scroll={scroll}
          slug={slug}
          menuLayout={menuLayout}
          additionalReference={additionalReference}
        />
      ) : (
        <StyledLinkGroup>
          <StyledLink to={to} aria-label={ariaLabel}>
            {icon && <StyledIcon>{icon}</StyledIcon>}
            {name && name}
          </StyledLink>
          {scroll ? null : <HoverLine $isSelected={isSelected} />}
        </StyledLinkGroup>
      )}
    </StyledNavItem>
  )
}

NavbarItem.propTypes = {
  ariaLabel: PropTypes.string,
  icon: PropTypes.any,
  links: PropTypes.arrayOf(PropTypes.object),
  name: PropTypes.string,
  slug: PropTypes.string.isRequired,
}

export default NavbarItem
